import * as types from './constants';

// Delete Smart Group
export const deleteSmartGroupRequest = data => (
  { type: types.DELETE_SMART_GROUP_REQUEST, payload: data }
);

export const deleteSmartGroupDone = data => (
  { type: types.DELETE_SMART_GROUP_DONE, payload: data }
);

export const deleteSmartGroupFailed = errors => (
  { type: types.DELETE_SMART_GROUP_FAILED, payload: errors }
);